import React, { useState } from "react";
import axios from "axios";
import logo from "../assets/logo-IRC.png";
import "./Auth.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getNodeApiBase } from "../utils/apiBase";

const Auth = () => {
  const navigate = useNavigate(); // useNavigate hook
  const [errorServer, seterrorServer] = useState(false);
  const [Nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [telephone, setTelephone] = useState("");
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const nodeApiBase = getNodeApiBase();

  // Simple, robust email regex (RFC 5322-lite), accepts common valid emails
  const isValidEmail = (val) => {
    const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return re.test(String(val).trim());
  };

  // Password strength validation
  const isStrongPassword = (val) => {
    // At least 8 chars, one number, one symbol
    return /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/.test(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset server-side flags on each submit
    setEmailExists(false);

    // Validate email format first
    if (!isValidEmail(email)) {
      setEmailError("Format d'email invalide.");
      return;
    } else {
      setEmailError("");
    }

    if (password !== confirmPassword) {
      setPasswordMismatch(true);
      return;
    }

    if (!isStrongPassword(password)) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères, un symbole et un chiffre.");
      return;
    }

    try {
      // 1) Ask backend to send a verification code first (no DB insert yet)
      await axios.post(`${nodeApiBase}/api/auth/send-verification-code`, { email });

      // 2) Save pending signup data locally; we'll complete signup after verification
      const pending = {
        Nom,
        prenom,
        email,
        telephone,
        password,
      };
      try {
        sessionStorage.setItem('pendingSignup', JSON.stringify(pending));
      } catch (_) {}

      toast.success(
        "Code de vérification envoyé. Veuillez vérifier votre e-mail.",
        { autoClose: 2000 }
      );
      setTimeout(() => {
        navigate(`/verify-email?email=${encodeURIComponent(email)}`);
      }, 900);

      // Clear sensitive fields locally
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error(error);
      seterrorServer(true);
    }
  };

  return (
    <>
      <div className="signup-page">
        <ToastContainer />
        <div className="auth__form-container">
          <div className="auth__form-container_fields">
            <div className="auth__form-container_fields-content">
              <div className="signup-card">
                <div className="signup-card__left">
                  <form onSubmit={handleSubmit}>
                    <p className="auth__form-container_title">Inscription</p>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="nom">Nom</label>
                <input
                  name="nom"
                  type="text"
                  placeholder="Nom"
                  value={Nom}
                  onChange={(e) => setNom(e.target.value)}
                  required
                />
              </div>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="prenom">Prenom</label>
                <input
                  name="prenom"
                  type="text"
                  placeholder="Prenom"
                  value={prenom}
                  onChange={(e) => setPrenom(e.target.value)}
                  required
                />
              </div>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="email">E-mail</label>
                <input
                  name="email"
                  type="text"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => {
                    const v = e.target.value;
                    setEmail(v);
                    // live-validate and clear on valid entry
                    if (!v) {
                      setEmailError("");
                    } else if (!isValidEmail(v)) {
                      setEmailError("Format d'email invalide.");
                    } else {
                      setEmailError("");
                    }
                  }}
                  required
                />
                {emailError && (
                  <p style={{ color: "red", marginTop: 6 }}>{emailError}</p>
                )}
                {emailExists && (
                  <p style={{ color: "red" }}>This email is already in use.</p>
                )}
              </div>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="telephone">Telephone</label>
                <input
                  name="telephone"
                  type="tel"
                  placeholder="Telephone"
                  value={telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                  required
                />
              </div>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="password">Mot de passe</label>
                <input
                  name="password"
                  type="password"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="auth__form-container_fields-content_input">
                <label htmlFor="confirmPassword">
                  Confirmer le mot de passe
                </label>
                <input
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirmer le mot de passe"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                {passwordMismatch && (
                  <p style={{ color: "red" }}>
                    Les mots de passe ne correspondent pas.
                  </p>
                )}
              </div>
                    <div className="auth__form-container_fields-content_button">
                      <button type="submit">S'inscrire</button>
                    </div>
                    <div className="account-link account-link--right">
                      <p>
                        <a href="/">
                          <span>Je suis déjà membre</span>
                        </a>
                      </p>
                    </div>
                  </form>
                </div>
                <div className="signup-card__right" aria-hidden="true">
                  <img src={logo} alt="Illustration d'inscription" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Auth;
